import { compareStrings, nullSafeGetOrElse } from './DataAccessUtils';
import { ROLE_TYPES } from './DataConstants';
import { isAllowedToPerform, isSupplierAllowedToAccess, PERMISSION_NAMES } from './AuthUtils';
import { infinityButNumber } from '../constants/general';

export const isInApprovalHierarchy = (currentUser, approvalHierarchy) => {
	const tiers = nullSafeGetOrElse('tierDetails', approvalHierarchy, []);
	const approvers = tiers.flatMap((tier) => tier.approvers);
	return approvers.some((approver) => approver.email === currentUser.email);
};

export const isUserAllowedToFullyApprove = (user, approvalHierarchy, companyConfig, amount = 0) => {
	if (approvalHierarchy) {
		const tiers = nullSafeGetOrElse('tierDetails', approvalHierarchy, []);
		const userTier = tiers.find((tier) =>
			tier.approvers.some((approver) => compareStrings(approver.email, user.email))
		);
		if (parseFloat(nullSafeGetOrElse('amountUpto', userTier, infinityButNumber)) >= amount) {
			return true;
		}
	} else {
		return user.userType === ROLE_TYPES.SUPPLIER
			? isSupplierAllowedToAccess(PERMISSION_NAMES.CAN_APPROVE_INVOICES, companyConfig, user.roles)
			: isAllowedToPerform(PERMISSION_NAMES.CAN_APPROVE_INVOICES, companyConfig, user.roles);
	}
	return false;
};

export const defaultTier = {
	name: '',
	approvers: [],
	showSearch: false,
	label: 1,
	id: 1,
};
